import PropTypes from 'prop-types';

export const CalculationIdPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
});

export const CalculationsIdPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
});
